<p>HOME</p>

<button *ngIf="isAdmin()" (click)="redirectToAdmin()">To Admin Stuff</button>

<app-logout-button></app-logout-button>
